// Keep source row IDs: a unique option still needs its original row for linked fields.
export function uniqueFileImportOptions(options = []) {
  const seen = new Set()
  return options.filter(option => {
    if (seen.has(option.input)) return false
    seen.add(option.input)
    return true
  })
}

export function getFormImportOptions(header, options = []) {
  if (!header?.file_import_unique) return options
  const firstByValue = new Map(uniqueFileImportOptions(header.col_dropdown_origin || [])
    .map(option => [option.input, option]))
  return uniqueFileImportOptions(options).map(option => firstByValue.get(option.input) || option)
}

export function findFileImportReferenceConflict(tableData, selectedColumns = []) {
  if (selectedColumns.length < 2) return null
  const firstRows = selectedColumns.map(() => new Map())
  for (let rowIndex = 1; rowIndex < tableData.length; rowIndex++) {
    const row = tableData[rowIndex]
    if (!Array.isArray(row)) continue
    const values = selectedColumns.map(columnIndex => row[columnIndex])
    for (let index = 0; index < selectedColumns.length; index++) {
      const first = firstRows[index].get(values[index])
      if (!first) {
        firstRows[index].set(values[index], { rowIndex, values })
      } else if (values.some((value, i) => !Object.is(value, first.values[i]))) {
        return {
          columnIndex: selectedColumns[index], value: values[index],
          firstRowIndex: first.rowIndex, firstValues: first.values,
        }
      }
    }
  }
  return null
}

export async function confirmFileImportReference({ tableData, selectedColumns, reference, swal }) {
  if (!reference) return true
  const conflict = findFileImportReferenceConflict(tableData, selectedColumns)
  if (!conflict) return true
  const result = await swal.fire({
    icon: 'warning',
    title: '중복 값의 참조 확인',
    text: `여러 열을 참조로 묶어 가져오면 중복 값은 하나의 옵션으로 표시됩니다. 같은 값에 서로 다른 묶음이 있어, 선택 시 해당 값이 처음 나타나는 최상단 행의 묶음을 사용합니다. 예: ${tableData[0][conflict.columnIndex]}의 '${String(conflict.value ?? '')}' → ${conflict.firstValues.map(value => String(value ?? '')).join(' / ')} (${conflict.firstRowIndex + 1}행). 최상단 값 사용을 허용하시겠습니까?`,
    showCancelButton: true,
    confirmButtonText: '최상단 값 사용 허용',
    cancelButtonText: '가져오기 취소',
    confirmButtonColor: '#687EFF',
    focusCancel: true,
    allowOutsideClick: false,
    didOpen: () => {
      for (const button of [swal.getConfirmButton(), swal.getCancelButton()]) {
        if (button) button.style.fontSize = '14px'
      }
    },
  })
  return result.isConfirmed === true
}
